/*
 * @Author: 刘小博
 * @Date: 2022-10-28 14:44:26
 * @LastEditTime: 2023-02-27 17:08:06
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\main.js
 * 文件备注
 */
import '@babel/polyfill'
import '@/utils/polyfill'
import Vue from 'vue'
import BaiduMap from 'vue-baidu-map'
import VueColumnsResizableVuetify from "vue-columns-resizable-vuetify/lib/vue-columns-resizable.common"
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import axios from './utils/axios'
import shrinkButton from '@/components/shrinkButton/shrinkButton'
import ViewHeader from '@/components/viewHeader/ViewHeader.vue'
import Pagination from '@/components/pagination/Pagination.vue'
import buryingPoint from './utils/buryingPoint'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@/utils/filter'
import '@/utils/directive'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/radar'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/effectScatter'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/dataset'
import 'echarts/map/js/world'
import 'zrender/lib/svg/svg'
import './style/index.less'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import chinaMap from '@/assets/china'
import VueDraggableResizable from 'vue-draggable-resizable';
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
Vue.component('vue-draggable-resizable', VueDraggableResizable);

// import './plugins/vxe-table'
ECharts.registerMap('china', chinaMap)

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(buryingPoint)
Vue.use(Antd)
Vue.use(VueColumnsResizableVuetify)
Vue.use(VXETable)
/* 注册全局组件 */
Vue.component('v-chart', ECharts)
Vue.component('shrinkButton', shrinkButton)
Vue.component('ViewHeader', ViewHeader)
Vue.component('Pagination', Pagination)

Vue.use(BaiduMap, {
  ak: 'BIMZtrvn1aXNWJbUeQpJ1dEAdQSAI9LV&s=1'
})
Vue.prototype.$axios = axios
Vue.prototype.$formRequest = axios.formRequest.post
Vue.config.productionTip = false

import Print from 'vue-print-nb'
Vue.use(Print)

// 判断浏览器版本
if (navigator.appName == 'Microsoft Internet Explorer') {
  let IEVersion = parseInt(
    navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')
  )
  store.commit('setIEVersion', IEVersion)
}

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
